import React from 'react';
import { animateScroll as scroll } from 'react-scroll';
import {
  FooterContainer,
  FooterWrap,
  SocialMedia,
  SocialMediaWrap,
  FooterTeam,
  FooterLink,
  BGMusic

} from './FooterElements';

const Footer = () => {
  const toggleHome = () => {
    scroll.scrollToTop();
  };
  return (
    <FooterContainer>
      <FooterWrap>
        <SocialMedia>
          <SocialMediaWrap>
            <FooterTeam>Team: <FooterLink target="_blank" href="https://twitter.com/tombheads">Tombheads</FooterLink>, <FooterLink target="_blank" href="https://twitter.com/yolofinancial">Funeral</FooterLink> and <FooterLink target="_blank" href="https://twitter.com/ftmdead">FTMdead</FooterLink>.
            </FooterTeam>
          </SocialMediaWrap>
        </SocialMedia>
      </FooterWrap>
    </FooterContainer>
  );
};

export default Footer;
